import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository, type UploadDocumentParams } from '../infra/ShipmentRepository'

export type UploadDocumentFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function uploadDocumentFactory({ shipmentRepository }: UploadDocumentFactoryDependencies) {
  return async function uploadDocument(params: UploadDocumentParams) {
    const { documentType } = params
    try {
      return await shipmentRepository.uploadDocument(params)
    } catch (error) {
      throw new Error(`Failed to upload ${documentType}`, { cause: error as Error })
    }
  }
}

export function uploadDocument(params: UploadDocumentParams) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const upload = uploadDocumentFactory({ shipmentRepository })

  return upload(params)
}
